import TaxonomiesTable from "./taxonomies-table";

export default TaxonomiesTable;
